import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminChemIqStatusComponent } from './admin-chem-iq-status.component';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { KeycloakGuard } from 'app/modules/auth/login/keycloak.guard';

const routes: Routes = [

  { path: '', canActivate: [KeycloakGuard], component: AdminChemIqStatusComponent },

];

@NgModule({
  declarations: [AdminChemIqStatusComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatIconModule,
  ]
})
export class AdminChemIqStatusModule { }
